import { TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import toast from "react-hot-toast";
import roles from "../../../@const/roles";
import { removePeople } from "../../../api/people/People";
import useAuth from "../../../hooks/useAuth";
import PencilAltIcon from "../../../icons/PencilAlt";
import TrashIcon from "../../../icons/Trash";
import DeleteModal from "../../DeleteModal";
import PermissionGuard from "../../PermissionGuard";
import EditPeopleModal from "./EditPeopleModal";
import ViewAndEditPeopleModal from "./ViewAndEditPeopleModal";

const SingleMember = ({ member, getAllPeopleUnderAdmin }) => {
  const [showEditPeopleModal, setShowEditPeopleModal] = useState(false);
  const [showViewAndEditPeopleModal, setShowViewAndEditPeopleModal] =
    useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { permissions } = useAuth();

  const deletePeople = async (peopleId) => {
    try {
      const res = await removePeople(peopleId);
      if (res.data.success) {
        toast.success("Member deleted");
        getAllPeopleUnderAdmin();
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <DeleteModal
        open={showDeleteModal}
        setOpen={setShowDeleteModal}
        onYesClick={() => deletePeople(member.id)}
        warningMessage="Are you sure you want to delete this member?"
      />
      {showViewAndEditPeopleModal && (
        <ViewAndEditPeopleModal
          showViewAndEditPeopleModal={showViewAndEditPeopleModal}
          setShowViewAndEditPeopleModal={setShowViewAndEditPeopleModal}
          getAllPeopleUnderAdmin={getAllPeopleUnderAdmin}
          member={member}
        />
      )}
      {showEditPeopleModal && (
        <EditPeopleModal
          showEditPeopleModal={showEditPeopleModal}
          setShowEditPeopleModal={setShowEditPeopleModal}
          getAllPeopleUnderAdmin={getAllPeopleUnderAdmin}
          member={member}
        />
      )}
      <TableRow hover>
        <TableCell
          onClick={() => setShowViewAndEditPeopleModal(true)}
          sx={{ cursor: "pointer" }}
        >{`${member?.first_name} ${member?.last_name}`}</TableCell>
        <TableCell>{member?.email || "-"}</TableCell>
        <TableCell>{member?.user_params?.designation || "-"}</TableCell>
        <TableCell>
          {member?.user_params?.get_department?.department || "-"}
        </TableCell>
        {(permissions["PEOPLE_UPDATE"] || permissions["PEOPLE_DELETE"]) && (
          <TableCell align="center">
            <PermissionGuard permissionCheck="PEOPLE_UPDATE" returnEmpty={true}>
              <PencilAltIcon
                title="Edit"
                onClick={() => setShowEditPeopleModal(true)}
                className="action-icon"
              />
            </PermissionGuard>
            <PermissionGuard permissionCheck="PEOPLE_DELETE" returnEmpty={true}>
              <TrashIcon
                title="delete"
                onClick={() => setShowDeleteModal(true)}
                className="action-icon"
              />
            </PermissionGuard>
          </TableCell>
        )}
      </TableRow>
    </>
  );
};

export default SingleMember;
